import { Button, Input, MenuItem, Modal, Select, Typography } from '@mui/material'
import { get, merge } from 'lodash'
import React from 'react'
import { Mutation, Query } from 'react-apollo'
import Loader from '../../../common/loader/Loader'
import { User } from '../../auth/types'
import withUser from '../../auth/withUser'
import { i18n } from '../../index'
import css from './links.css'
import { addWeeklyInfoLink, fetchFileLinks, fetchWeeklyInfoLinks } from './linksQueries'

type LinksModalProps = {
  isOpen: boolean
  onClose: (...args: Array<any>) => any
  stationId: string
  linksType: string
  companyId?: string
}

type LinksModalState = {
  fileName: string
  href: string
}

type FileLink = {
  fileName: string
  id: string
  href: string
}

type InjectedProps = {
  user: User
}

@withUser
class LinksModal extends React.Component<LinksModalProps, LinksModalState> {
  state = {
    fileName: '',
    href: '',
  }

  onLinkSelect = (link: FileLink | null) => {
    if (link) {
      this.setState({
        fileName: link.fileName,
        href: link.href,
      })
    } else {
      this.setState({
        fileName: '',
        href: '',
      })
    }
  }
  onModalClose = () => {
    const { onClose } = this.props
    this.setState({
      fileName: '',
      href: '',
    })
    onClose()
  }
  onSubmit = (onMutate: (...args: Array<any>) => any) => {
    const { stationId, linksType, user } = this.props as LinksModalProps & InjectedProps
    const { fileName, href } = this.state
    const isSokAdmin = user.userType === 'SokAdmin'

    if (fileName.trim().length > 0 && href.trim().length > 0) {
      onMutate({
        variables: {
          stationId: isSokAdmin ? null : stationId,
          fileName,
          href,
          type: linksType,
        },
      })
    }

    this.onModalClose()
  }

  render() {
    const { isOpen, stationId, linksType, companyId } = this.props
    const { fileName, href } = this.state
    return (
      <div>
        <Modal
          open={isOpen}
          onClose={this.onModalClose}
          aria-labelledby='links-modal'
          aria-describedby='add-links-modal'
        >
          <div className={css.modal}>
            <div className={css.modalInputs}>
              <Query
                query={fetchFileLinks}
                variables={{
                  companyId,
                }}
              >
                {({ loading, error, data }) => {
                  const stationsLinks: { fileName: string }[] = get(data, 'fileLinks', [])
                  const aokLinks = get(data, 'aokFileLinks', [])
                  merge(stationsLinks, aokLinks)
                  const linkOptions = stationsLinks.map((x, i) => ({
                    value: i,
                    label: x.fileName,
                  }))
                  return (
                    <Loader
                      {...{
                        loading,
                        error,
                      }}
                    >
                      <Typography variant='h6' gutterBottom>
                        {i18n.t('weeklyInfo.links.modalTitle')}
                      </Typography>

                      <Select
                        onChange={(e) => this.onLinkSelect(stationsLinks[e.target.value] || null)}
                        className={css.linkSelect}
                        value={-1}
                      >
                        <MenuItem value={-1}>{i18n.t('weeklyInfo.links.emptyOption')}</MenuItem>
                        {linkOptions.map((x, i) => (
                          <MenuItem key={i} value={i}>
                            {x.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </Loader>
                  )
                }}
              </Query>
              <Input
                className={css.modalInput}
                type={'text'}
                value={fileName}
                placeholder={i18n.t('weeklyInfo.links.fileName')}
                onChange={(e) =>
                  this.setState({
                    fileName: e.target.value,
                  })
                }
              />

              <Input
                className={css.modalInput}
                type={'text'}
                value={href}
                placeholder={i18n.t('weeklyInfo.links.href')}
                onChange={(e) =>
                  this.setState({
                    href: e.target.value,
                  })
                }
              />

              <div className={css.modalActions}>
                <Mutation
                  mutation={addWeeklyInfoLink}
                  refetchQueries={[
                    {
                      query: fetchWeeklyInfoLinks,
                      variables: {
                        stationId,
                        type: linksType,
                      },
                    },
                  ]}
                >
                  {(onMutate) => (
                    <div className={css.linksInputContainer}>
                      <Button onClick={() => this.onSubmit(onMutate)} color={'primary'} variant='contained'>
                        {i18n.t('weeklyInfo.button.addLinks')}
                      </Button>
                    </div>
                  )}
                </Mutation>
                <Button
                  className={css.modalButton}
                  color={'secondary'}
                  variant={'contained'}
                  onClick={this.onModalClose}
                >
                  {i18n.t('weeklyInfo.button.cancel')}
                </Button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}

export default LinksModal
